import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadUserSourceStatusReportService {


  url = environment.serverAPI9 + "/api/leadUserSourceStatusReport";
  url1 = environment.serverAPI9 + "/api/source/user/report";

  constructor(private http: HttpClient) { }

  // searchLeadUserSourceStatusReport(query, Page: any, size: any, sort: any): Observable<Object> {
  //   return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  // }

  // searchLeadUserSourceStatusReport(query, Page: any, size: any, sort: any): Observable<Response[]> {
  //   let object = {
  //     searchQuery: query.split("'").join('')
  //   }
  //   return this.http.post<Response[]>(`${this.url}/condition?page=${Page}&size=${size}&sort=${sort}`, object)
  // }


  searchLeadUserSourceStatusReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null // Remove single quotes from the query
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  getLeadUserSourceStatusReport(Page: number, size: number, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  searchDynamicLeadReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url1}${queryParams}`, requestBody);
  }



}
